function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.18427 0.299094C7.58609 0.108761 6.93352 0 6.26736 0C4.35044 0 2.62385 0.870091 1.46826 2.2432L4.43201 4.73112L8.18427 0.299094Z",
  fill: "#1A73E8"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M1.46828 2.24316C0.557402 3.33078 0 4.74467 0 6.26733C0 7.45011 0.231118 8.40177 0.625378 9.25827L4.43202 4.73108L1.46828 2.24316Z",
  fill: "#EA4335"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M6.28107 3.8746C7.6134 3.8746 8.68742 4.94862 8.68742 6.28094C8.68742 6.86554 8.46989 7.40934 8.11642 7.83079C8.11642 7.83079 10.0061 5.574 11.8551 3.38517C11.0938 1.9169 9.77503 0.802093 8.1844 0.299072L4.43213 4.7311C4.88077 4.21448 5.53334 3.8746 6.28107 3.8746Z",
  fill: "#4285F4"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M6.28108 8.67374C4.94875 8.67374 3.87473 7.59972 3.87473 6.26739C3.87473 5.6828 4.07866 5.139 4.43213 4.73114L0.625488 9.25833C1.27806 10.6994 2.36567 11.8686 3.48047 13.3233L8.11642 7.81724C7.66778 8.34745 7.01522 8.67374 6.28108 8.67374Z",
  fill: "#FBBC04"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M8.03485 14.8459C10.1285 11.5695 12.562 10.0876 12.562 6.28096C12.562 5.23414 12.3037 4.25528 11.8551 3.38519L3.48047 13.3233C3.83394 13.7855 4.20101 14.3157 4.55449 14.8595C5.83243 16.8308 5.47896 18 6.29467 18C7.11038 18 6.7569 16.8172 8.03485 14.8459Z",
  fill: "#34A853"
});

var SvgGoogleMapsIcon = function SvgGoogleMapsIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 18,
    viewBox: "0 0 13 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGoogleMapsIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/googleMapsIcon.5553d904.svg";
export { ForwardRef as ReactComponent };